import { useState } from "react";
import { useTranslation } from "react-i18next";
import { categories } from "@/mocks/data";

export default function Hero() {
  const { t } = useTranslation();
  const [selectedCat, setSelectedCat] = useState("");

  const handleCategoryChange = (e: React.ChangeEvent<HTMLSelectElement>) => {
    const url = e.target.value;
    if (url) {
      setSelectedCat(url);
      window.open(url, "_blank");
    }
  };

  return (
    <section id="hero" className="relative w-full min-h-screen flex flex-col items-center justify-center overflow-hidden">
      <div className="absolute inset-0">
        <img
          src="https://readdy.ai/api/search-image?query=Artistic%20fashion%20editorial%20background%20with%20flowing%20silk%20fabric%20in%20rich%20terracotta%20coral%20and%20olive%20green%20tones%2C%20abstract%20textile%20art%20composition%2C%20soft%20ethereal%20lighting%2C%20luxury%20brand%20atmosphere%2C%20elegant%20minimalist%20aesthetic%20with%20organic%20movement&width=1600&height=900&seq=hero-v2-bg-2026&orientation=landscape"
          alt="Hipobuy Spreadsheet guide complet"
          title="Hipobuy Spreadsheet - Guide Complet 2026"
          className="w-full h-full object-cover object-top"
        />
        <div className="absolute inset-0 bg-gradient-to-b from-black/50 via-black/30 to-black/55"></div>
      </div>

      <div className="relative z-10 w-full flex flex-col items-center px-4 pt-20 pb-10">
        <h1 className="text-center font-heading">
          <span className="block text-4xl md:text-6xl lg:text-7xl font-bold text-white leading-tight drop-shadow-lg">
            {t("hero.h1.line1")}
          </span>
          <span className="block text-3xl md:text-5xl lg:text-6xl font-bold text-white/95 mt-2 md:mt-3 drop-shadow-md">
            {t("hero.h1.line2")}
          </span>
        </h1>

        <p className="mt-6 md:mt-8 max-w-2xl text-center text-white/90 text-sm md:text-base leading-relaxed drop-shadow-sm">
          {t("hero.subtitle")}
        </p>

        <div className="mt-8 md:mt-10">
          <select
            value={selectedCat}
            onChange={handleCategoryChange}
            className="w-72 md:w-80 h-12 px-4 rounded-lg bg-white/95 text-foreground-800 text-sm font-medium border border-white/30 cursor-pointer appearance-none bg-no-repeat pr-10 focus:outline-none focus:ring-2 focus:ring-primary-400 shadow-lg"
            style={{ backgroundImage: "url('data:image/svg+xml;charset=utf-8,%3Csvg%20xmlns%3D%22http%3A%2F%2Fwww.w3.org%2F2000%2Fsvg%22%20viewBox%3D%220%200%2024%2024%22%3E%3Cpath%20fill%3D%22%23333%22%20d%3D%22M7%2010l5%205%205-5z%22%2F%3E%3C%2Fsvg%3E')", backgroundSize: "20px", backgroundPosition: "right 12px center" }}
          >
            <option value="">{t("hero.dropdown.placeholder")}</option>
            {categories.map((cat) => (
              <option key={cat.id} value={cat.url}>
                {cat.name}
              </option>
            ))}
          </select>
        </div>

        <div className="flex flex-col sm:flex-row gap-4 mt-8 md:mt-10">
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="px-8 py-3.5 bg-white/20 backdrop-blur-sm text-white text-sm font-semibold rounded-lg hover:bg-white/30 transition-all whitespace-nowrap text-center shadow-lg"
          >
            {t("hero.cta.primary")}
          </a>
          <a
            href="https://kaspreadsheet.com"
            target="_blank"
            rel="noopener nofollow"
            className="px-8 py-3.5 bg-primary-500 text-white text-sm font-semibold rounded-lg hover:bg-primary-600 transition-all whitespace-nowrap text-center shadow-lg"
          >
            {t("hero.cta.secondary")}
          </a>
        </div>

        <div className="flex flex-wrap items-center justify-center gap-4 md:gap-8 mt-10 md:mt-12">
          <span className="text-white/80 text-xs flex items-center gap-1.5 drop-shadow-sm">
            <i className="ri-check-line text-primary-400 text-sm"></i>
            {t("hero.trust.line1")}
          </span>
          <span className="text-white/80 text-xs flex items-center gap-1.5 drop-shadow-sm">
            <i className="ri-check-line text-primary-400 text-sm"></i>
            {t("hero.trust.line2")}
          </span>
          <span className="text-white/80 text-xs flex items-center gap-1.5 drop-shadow-sm">
            <i className="ri-check-line text-primary-400 text-sm"></i>
            {t("hero.trust.line3")}
          </span>
        </div>

        <div className="mt-12 md:mt-16 w-full overflow-hidden">
          <div className="flex flex-wrap justify-center gap-2 md:gap-3">
            {categories.map((cat) => (
              <a
                key={cat.id}
                href={cat.url}
                target="_blank"
                rel="noopener nofollow"
                className="px-4 py-2 bg-white/15 backdrop-blur-sm text-white/90 text-xs md:text-sm rounded-full hover:bg-white/30 transition-all whitespace-nowrap"
              >
                {cat.name}
              </a>
            ))}
          </div>
        </div>
      </div>

      <a
        href="#categories"
        className="absolute bottom-8 left-1/2 -translate-x-1/2 z-10 w-10 h-10 flex items-center justify-center text-white/70 hover:text-white transition-colors"
        aria-label="Scroll down"
      >
        <i className="ri-arrow-down-line text-2xl animate-bounce"></i>
      </a>
    </section>
  );
}